import { render } from "./UploadProfile.vue?vue&type=template&id=fcab98b6&ts=true"
import script from "./UploadProfile.vue?vue&type=script&lang=ts"
export * from "./UploadProfile.vue?vue&type=script&lang=ts"

import "./UploadProfile.vue?vue&type=style&index=0&id=fcab98b6&lang=css"

import exportComponent from "/var/www/rewards/runners/admin/root/reward-admin/reward-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__